import React from "react";
import styled from "styled-components";
import fonts from "@/design/typography";
import colors from "@/design/colors";

interface RowHeaderTableProps {
  data: { label: string; value: React.ReactNode; required?: boolean }[];
  highlightHeader?: string[];
  highlightRows?: string[];
}

const RowHeaderTable = ({
  data,
  highlightHeader,
  highlightRows,
}: RowHeaderTableProps) => {
  return (
    <TableContainer>
      <StyledTable>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx}>
              <th
                className={
                  highlightHeader?.includes(item.label) ? "highlightHeader" : ""
                }
              >
                {item.label}
                {item.required && (
                  <span
                    style={{
                      color: "red",
                      position: "relative",
                      top: -4,
                      fontSize: 6,
                      marginLeft: 4,
                      verticalAlign: "middle",
                    }}
                  >
                    ●
                  </span>
                )}
              </th>
              <td
                className={
                  highlightRows?.includes(item.label) ? "highlight" : ""
                }
              >
                {item.value}
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};

export default RowHeaderTable;

/* 스타일 정의 */
const TableContainer = styled.div`
  width: 100%;
  border: 1px solid ${colors.gray200};
  border-radius: 8px;
  overflow: hidden;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: ${fonts.label4Medium.fontSize};
  font-family: ${fonts.label4Medium.fontFamily};
  line-height: ${fonts.label4Medium.lineHeight};

  th {
    width: 160px;
    text-align: left;
    padding: 12px;
    background-color: ${colors.gray100};
    border-bottom: 1px solid ${colors.gray200};
    border-right: 1px solid ${colors.gray200};
    color: ${colors.gray700};
    text-align: center;
  }

  td {
    padding: 12px;
    border-bottom: 1px solid ${colors.gray200};
    color: ${colors.gray900};
    vertical-align: middle;
    background-color: ${colors.white};
  }

  th.highlightHeader {
    background-color: ${colors.blue50};
  }

  td.highlight {
    color: ${colors.blue600};
  }

  tr:last-child th,
  tr:last-child td {
    border-bottom: none;
  }

  ${({ theme }) => theme.device.mobile} {
    th,
    td {
      padding: 8px 12px;
      font-size: ${fonts.label5Medium.fontSize};
    }

    th {
      width: 100px;
    }
  }
`;
